import Stack from '@mui/material/Stack'

import { GridCellParams } from '@mui/x-data-grid'

import { Text } from '@mxenabled/mxui'

import { useTransactionStore } from '../../../../../common'
import { TransactionType } from '../../../../../core'

import { useTransactionsUiStore } from '../../../../context/hooks'
import { formatCurrency } from '../../../../../core/utils/NumberFormatting'

const AmountCell = (params: GridCellParams) => {
  const { associatedBeats } = useTransactionStore()
  const { showInsights } = useTransactionsUiStore()

  const { amount, transaction_type } = params.row
  const beat = associatedBeats.find((beat) => beat.associated_transaction_guid === params.row.guid)

  const isCredit = transaction_type === TransactionType.CREDIT

  return (
    <Stack alignItems="flex-end" tabIndex={params.tabIndex}>
      <Text bold={isCredit} color={isCredit ? 'success.main' : 'text.primary'} variant="body2">
        {isCredit ? '+' : ''}
        {formatCurrency(amount, '0,0.00')}
      </Text>
      {beat && showInsights && (
        <Text bold={true} color="primary.light" variant="caption">
          {beat.short_title}
        </Text>
      )}
    </Stack>
  )
}

export default AmountCell
